export const LOCAL_AUTH_STORAGE_KEYS = {
  token: "token",
  user: "user",
  userDisplayName: "userDisplayName",
  email: "email",
  accountId: "account_id",
  firstLogin: "first_login",
  pendingLoginEmail: "pending_login_email",
  rememberedEmail: "remember_email",
  webpushUrl: "webpush_url",
  refreshToken: "refresh_token",
  showBreak: "showBreak",
} as const;

export const LoginType = {
  o365: "o365",
  google: "google",
} as const;
